<script lang="ts" setup>
defineProps<{
  viewMode: "narrow" | "wide";
}>();
</script>

<template>
  <div class="mx-auto w-full" :class="viewMode === 'narrow' ? 'lg:w-1/2 xl:w-1/3' : 'lg:w-3/4 xl:w-5/6'">
    <slot />
  </div>
</template>

<style scoped>

</style>
